module.exports = __webpack_public_path__ + "img/Ill_No Data.8958acb6.svg";